import styled from "styled-components";
import peopleImage from '../resources/homepage-bg-5.svg';
import logo from '../resources/youth_gps_logo.svg';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { generateClient } from 'aws-amplify/api';
import { listSubmissions } from '../graphql/queries'; // adjust path if needed

const client = generateClient();

const normalizeDynamo = (obj) => {
  const result = {};
  for (const [key, val] of Object.entries(obj)) {
    if (val?.S !== undefined) result[key] = val.S;
    else if (val?.N !== undefined) result[key] = Number(val.N);
    else if (val?.BOOL !== undefined) result[key] = val.BOOL;
    else if (typeof val === "object" && !Array.isArray(val)) {
      result[key] = normalizeDynamo(val); // recurse
    } else {
      result[key] = val;
    }
  }
  return result;
};
const HomeLoginPage = () => {
    const [id, setId] = React.useState("");
    const history = useNavigate();

    React.useEffect(() => {
        sessionStorage.clear();
    }, []);

    const onIdChangeFunction = (e) => {
        setId(e.target.value);
    };

    const onLogin = async () => {
      if (!id.trim()) {
        toast.error("Please enter your participant ID.");
        return;
      }
    
      const participantId = String(id.trim()); // ✅ force to string
    
      // 🧹 Clear session storage each time before a new login
      sessionStorage.clear();
      sessionStorage.setItem("PARTID", participantId);
      sessionStorage.setItem("logged_in", true);
      sessionStorage.setItem("selectedPageIndex", 0);
    
      try {
        console.log("🔎 Looking up participantId:", participantId);
    
        const result = await client.graphql({
          query: listSubmissions,
          variables: {
            filter: {
              participantId: { eq: participantId }, // ✅ now always string
            },
            limit: 50, // fetch more in case we need to sort/filter
          },
        });
    
        let submissions = result?.data?.listSubmissions?.items || [];
        console.log("📊 Raw submissions fetched:", submissions);
    
        // ✅ Normalize formType check (trim + uppercase)
        submissions = submissions.filter(
          (s) => (s.formType || "").trim().toUpperCase() === "MI1"
        );
    
        console.log("📊 Filtered MI1 submissions (count):", submissions.length);
    
        // ✅ Sort by createdAt (latest first)
        submissions = submissions.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
    
        if (submissions.length > 0) {
          const latest = submissions[0];
          console.log("✅ Latest MI1 submission:", latest);
    
          let demographics = {};
          if (latest.demographics) {
            try {
              demographics = JSON.parse(latest.demographics);
            } catch {
              demographics = latest.demographics;
            }
          }
    
          let raw = {};
          if (latest.raw) {
            try {
              raw = JSON.parse(latest.raw);
            } catch {}
          }
    
          // ✅ Only save for THIS participantId
          Object.entries({ ...demographics, ...raw }).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
              sessionStorage.setItem(key, value);
            }
          });
    
          if (raw.age || demographics.age) {
            sessionStorage.setItem("candidate_info_complete", "true");
          }
        } else {
          console.log("❌ No MI1 submission found for this ID:", participantId);
          sessionStorage.setItem("candidate_info_complete", "false");
        }
      } catch (err) {
        console.error("❌ Error fetching submissions:", err);
        toast.error("Error checking participant record. Please try again.");
      }
    
      // 🚀 Redirect
      setTimeout(() => {
        history("/MI");
      }, 100);
    };
    
  
    return (
        <Home>
            <ToastContainer position="top-center" closeOnClick />
            <div className='MainDiv'>
            <ImageDiv />
                <div className="textDiv">
                    <img width="250px" height="120px" src={logo} alt="Logo" />
                    <img className="portrait-people" src={peopleImage} alt="People" />
                    <InnerDiv>
                        <Welcome>Welcome!</Welcome>
                        <p style={{ margin: '20px 0' }}>
                            This survey test will ask questions about your alcohol, substance use and sexual behaviours and provide you personalized feedback. It will take about 20-30 minutes to complete. The survey is being done by the University of South Florida to explore the use of alcohol and other substances among young adults. Your identity will not be recorded with any of the responses you share with us.
                        </p>
                        <p style={{ marginBottom: '40px' }}>
                            Please provide your participant ID in the box below. If you are not sure what your participant ID is, please ask your Peer Navigator.
                        </p>
                        <div>
                            <input
                                onChange={onIdChangeFunction}
                                className="idInput"
                                placeholder='Your ID'
                                value={id}
                            />
                            <LoginBtn
                                disabled={id.trim() === ""}
                                style={{
                                    backgroundColor: id.trim() === "" ? "grey" : "#025dc7",
                                    color: id.trim() === "" ? "#c4b8b8" : "white",
                                    border: id.trim() === "" ? "grey" : "#025dc7"
                                }}
                                onClick={onLogin}
                            >
                                Let's Get Started
                            </LoginBtn>
                        </div>
                        <Admin />
                    </InnerDiv>
                </div>
            </div>
        </Home>
    );
};

// Styled Components

const Home = styled.article`
  text-align: center;
  color: black;
  position: relative;
  width: 100%;
  height: 100%;

  .MainDiv {
    height: 100%;
    display: grid;
    grid-template-columns: 50% 50%;
    align-items: center;

    > div:nth-child(2) {
      margin: 20px;
    }
  }

  img {
    margin: 20px 0;
  }

  /* ✅ Default: hide portrait image */
  .portrait-people {
    display: none;
  }

  /* ✅ Portrait / small screens */
  @media (max-width: 848px) {
    .MainDiv {
      grid-template-columns: 100%;
      background-color: #D3EEFF;
      overflow-y: auto;
      align-items: flex-start;
    }

    /* 👇 Force portrait image to show */
    .portrait-people {
      display: block !important;   /* override default */
      width: 90%;
      max-width: 500px;
      margin: 15px auto 25px;
    }

    .textDiv {
      img:first-child { /* logo */
        width: 150px;
        height: auto;
        margin-bottom: 10px;
      }
    }
  }
`;


const InnerDiv = styled.div`
  .idInput {
    border: #D3EEFF;
    background: #D3EEFF;
    height: 35px;
    width: 35%;
    text-align: center;
    outline: none;
    transition: 0.5s;
  }
  @media (max-width: 848px) {
    background-color: white;
    justify-self: center;
    padding: 15px;
    p {
      line-height: 21px;
      font-size: 12px;
    }
    h2 {
      line-height: 25px;
      font-size: 20px;
    }
  }
`;

const Welcome = styled.h2`
  margin: 0;
`;

const ImageDiv = styled.div`
  background-image: url(${peopleImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  width: 100%;
  height: 100%;

  /* ✅ Hide the background version on portrait */
  @media (max-width: 848px) {
    display: none;
  }
`;


const LoginBtn = styled.button`
  border: #025dc7;
  background: #025dc7;
  height: 35px;
  width: 35%;
  text-align: center;
  outline: none;
  transition: 0.5s;
  color: white;
  margin: 0 20px;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
`;

const Admin = styled.section`
  font-size: 12px;
  .admin {
    color: #025dc7;
    cursor: pointer;
  }
`;

export default HomeLoginPage;
